/** NVL Button — pill-shaped, follows blueprint .btn / .btn-primary / .btn-ghost language.
 *  Variants: primary (plum gradient), ghost (bordered), sm size.
 */
import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../lib/cn";

const base =
  "inline-flex items-center justify-center gap-2.5 font-semibold tracking-[0.01em] rounded-full whitespace-nowrap transition-[transform,background,box-shadow,border-color] duration-300 ease-nvl active:translate-y-px active:scale-[0.99] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mauve focus-visible:ring-offset-2 focus-visible:ring-offset-bg disabled:opacity-50 disabled:pointer-events-none";

const variants = {
  primary:
    "text-white shadow-[0_10px_30px_-10px_var(--glow-plum),inset_0_0_0_1px_rgba(255,255,255,0.06)] hover:-translate-y-[2px] hover:shadow-[0_16px_40px_-10px_var(--glow-plum),inset_0_0_0_1px_rgba(255,255,255,0.12)]",
  ghost:
    "bg-surface text-text border border-line-2 hover:border-mauve hover:bg-surface-2 hover:-translate-y-[2px]",
  link: "text-text hover:text-mauve underline-offset-4 hover:underline",
};

const sizes = {
  default: "px-6 py-[13px] text-[14.5px]",
  sm: "px-4 py-[9px] text-[13px]",
  lg: "px-7 py-4 text-[15px]",
};

export const Button = forwardRef(function Button(
  { className, variant = "primary", size = "default", asChild = false, style, ...props },
  ref
) {
  const Comp = asChild ? Slot : "button";
  const primaryBg =
    variant === "primary"
      ? { background: "linear-gradient(135deg, var(--plum-bright), var(--plum))" }
      : undefined;
  return (
    <Comp
      ref={ref}
      style={{ ...primaryBg, ...style }}
      className={cn(base, variants[variant], sizes[size], className)}
      {...props}
    />
  );
});
